import React, { useState, createContext } from 'react'
import { api } from '../utils/index'

const volumeReportFilterDataContext = createContext([])

const FilterDataProvider = ({ children, path = 'volume-report-scheduled/' }) => {
  const [filteredData, setFilteredData] = useState({})

  const [actualPage, setActualPage] = useState(1)

  const [queryParams, setQueryParams] = useState({})

  const getFilteredData = (params) => {
    setQueryParams(params)
    api
      .get(path, {
        params: params,
      })
      .then((response) => {
        setFilteredData(response.data)
      })
  }

  return (
    <volumeReportFilterDataContext.Provider
      value={[filteredData, setFilteredData, getFilteredData, queryParams, actualPage, setActualPage]}
    >
      {children}
    </volumeReportFilterDataContext.Provider>
  )
}

export { volumeReportFilterDataContext, FilterDataProvider }
